
export default {
    name: 'monkey',
    classPrefix: 'm'
}
